import type { FormInstance }     from 'antd';
import { AppFormComponent }      from 'components/App/AppForm';
import React                     from 'react';
import { Col }                   from 'antd';
import { Form }                  from 'antd';
import Row                       from 'components/App/Row';
import RichTextEditor            from 'components/App/RichTextEditor';
import FormattedMessageWrapper   from 'components/App/FormattedMessageWrapper';
import FormItemDragger           from 'components/App/FormItemDragger';
import handleFormError           from 'utils/handleFormError';
import StandDocumentMediaModel   from 'models/StandDocumentMediaModel';
import StandDocumentMessageModel from 'models/StandDocumentMessageModel';
import type { RefObject }        from 'react';
import StandModel                from 'models/StandModel';

interface StandDocumentMessageFormProps {
  onSuccess?: (standDocumentMessage: StandDocumentMessageModel) => void;
  stand: StandModel;
  standDocumentMessage: StandDocumentMessageModel;
}

class StandDocumentMessageForm extends AppFormComponent<StandDocumentMessageFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

  public componentDidMount() {
    const { standDocumentMessage } = this.props;

    this.formRef.current?.setFieldsValue({
      attachments: [],
      content: standDocumentMessage.content,
    });
  }

  public render() {
    return (
      <Form ref={this.formRef}>
        <Row>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Message" />}
              labelCol={{ span: 24 }}
              name="content"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Contenu manquant" />,
                  required: true,
                },
              ]}
            >
              <RichTextEditor style={{ height: 150, marginBottom: 32 }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <FormItemDragger name="attachments" />
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { onSuccess, stand, standDocumentMessage } = this.props;

    const values = await this.formRef.current?.validateFields();

    try {
      await standDocumentMessage.patch({
        content: values.content,
        stand: stand.iri,
      });

      for (let i = 0; i < values.attachments.length; i += 1) {
        await this.uploadStandDocumentMedia(
          values.attachments[i].originFileObj,
          standDocumentMessage,
        );
      }

      if (onSuccess) {
        onSuccess(standDocumentMessage);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };

  private uploadStandDocumentMedia = async (file: any, standDocumentMessage: StandDocumentMessageModel) => {
    const standDocumentMediaModel = new StandDocumentMediaModel();

    standDocumentMediaModel.set({
      file,
      standDocumentMessage: standDocumentMessage.iri,
    });

    await standDocumentMediaModel.save();

    return standDocumentMediaModel;
  };
}

export default StandDocumentMessageForm;
